import { GeneriskAction, GeneriskModel } from "../GeneriskeRapporter/update"
import React from "react"
import tw from "twin.macro"
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core"
import { number } from "purify-ts"
import { Just, Nothing } from "purify-ts/Maybe"
import { ReportType } from "../../models/ReportType"

interface FormatSelectionProps {
  generiskState: GeneriskModel;
  generiskDispatch: React.Dispatch<GeneriskAction>;
}

export default function FormatSelection({
  generiskState,
  generiskDispatch,
}: FormatSelectionProps) {
  if (generiskState.selectedReportType.isNothing()) {
    return null
  }

  const type = generiskState.selectedReportType.extract()?.id ?? 0

  if (
    type === ReportType.RELASJON_EXCEL ||
    type === ReportType.RELASJON_GEOPACKAGE
  ) {
    return (
      <>
        <h3 style={tw`text-xl font-bold text-left m-0 w-full`}>Format</h3>
        <FormControl component="fieldset">
          <RadioGroup
            value={generiskState.selectedReportType.extractNullable()?.id ?? 0}
            onChange={event =>
              number.decode(Number(event.target.value)).caseOf({
                Left: e => {
                  console.log(e)
                },
                Right: value => {
                  if (
                    value === ReportType.RELASJON_EXCEL ||
                    value === ReportType.RELASJON_GEOPACKAGE
                  ) {
                    const selectedReportType = generiskState.reportTypes.find(
                      report => report.id === value
                    )
                    generiskDispatch({
                      type: "SelectReportType",
                      payload: selectedReportType
                        ? Just(selectedReportType)
                        : Nothing,
                    })
                  }
                },
              })
            }
          >
            <FormControlLabel
              value={ReportType.RELASJON_EXCEL}
              style={tw`flex flex-row m-0`}
              control={<Radio color="secondary" />}
              label="Excel"
              labelPlacement="top"
            />
            <FormControlLabel
              value={ReportType.RELASJON_GEOPACKAGE}
              style={tw`flex flex-row m-0`}
              control={<Radio color="secondary" />}
              label="GeoPackage"
              labelPlacement="top"
            />
          </RadioGroup>
        </FormControl>
      </>
    )
  }

  return null;
}
